<script setup>
import { computed } from 'vue';
import Draggable from 'vuedraggable';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  stages: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['delete', 'edit', 'reorder']);

const orderedStages = computed({
  get: () => props.stages,
  set: stages => emit('reorder', stages),
});
</script>

<template>
  <Draggable
    v-model="orderedStages"
    item-key="id"
    handle=".drag-handle"
    animation="200"
    class="flex flex-col gap-3"
    :disabled="isLoading"
  >
    <template #item="{ element: stage, index }">
      <article class="flex items-center gap-3 p-4 rounded-lg border border-n-weak bg-n-background">
        <span class="drag-handle cursor-grab text-n-slate-10 i-lucide-grip-vertical" />
        <span class="flex items-center justify-center size-7 rounded-full bg-n-slate-3 text-sm text-n-slate-11">
          {{ index + 1 }}
        </span>
        <div class="min-w-0 flex-1">
          <h3 class="font-medium truncate text-n-slate-12">{{ stage.name }}</h3>
          <p class="text-sm truncate text-n-slate-11">{{ stage.label.title }}</p>
        </div>
        <div class="flex gap-1">
          <Button
            icon="i-lucide-pencil"
            slate
            sm
            :disabled="isLoading"
            @click="emit('edit', stage)"
          />
          <Button
            icon="i-lucide-trash-2"
            slate
            sm
            class="hover:enabled:text-n-ruby-11"
            :disabled="isLoading"
            @click="emit('delete', stage)"
          />
        </div>
      </article>
    </template>
  </Draggable>
</template>
